import { Configure, ConfigureProps, Index } from "react-instantsearch";
import SearchHits from "../SearchHits";
import { WeekRangeObj } from "@/components/Search/types";
import getWeekRangeTitle from "./utils/getWeekRangeTitle";
import getWeekRangeFilters from "./utils/getWeekRangeFilters";
import { DURATION_WEEK_RANGE } from "@/components/Search/constants";
import { SearchPageTemplateTestResult } from "@/monarch/rules/searchPageTemplate/types";
import useSearchPageTemplate from "@/monarch/rules/searchPageTemplate/useSearchPageTemplate";

export interface WeekRangeResultRowProps {
  searchIndex: string;
  configForSearch: ConfigureProps;
  weeksToCompleteRange: WeekRangeObj;
  itemsPerRow?: number;
}

const WeekRangeResultRow = ({
  searchIndex,
  configForSearch,
  weeksToCompleteRange,
  itemsPerRow = 3,
}: WeekRangeResultRowProps) => {
  const searchPageTemplateTestResult: SearchPageTemplateTestResult | null =
    useSearchPageTemplate();
  const titleFromMonarch =
    searchPageTemplateTestResult?.data?.timelineModule?.title;
  const title = titleFromMonarch || getWeekRangeTitle(weeksToCompleteRange);
  const filters = getWeekRangeFilters(weeksToCompleteRange);
  return (
    <>
      <Index indexName={searchIndex}>
        <Configure
          {...configForSearch}
          hitsPerPage={itemsPerRow}
          filters={filters}
        />
        <SearchHits title={title} facetForLink={DURATION_WEEK_RANGE} />
      </Index>
    </>
  );
};

export default WeekRangeResultRow;
